export enum enumDependencyModelType {
  IMPORTER,
  CONSIGNEE,
  MANUFACTURER,
}
